export const screenBasisPermission = (consultationId,patientId,mode, hasPermission,navigate, state = {})=>{
    const options = { state };
    if(hasPermission('HISTORY_VIEW'))
    {
        navigate(`/consultation/${consultationId}/patient/${patientId}/A/history?mode=${mode}`, options)
        return
    }
    if(hasPermission('VITALS_VIEW'))
    {
        navigate(`/consultation/${consultationId}/patient/${patientId}/A/vitals?mode=${mode}`, options)
        return
    }
    if(hasPermission('OBSERVATIONS_VIEW'))
    {
        navigate(`/consultation/${consultationId}/patient/${patientId}/A/observation?mode=${mode}`, options)
        return
    }
    if(hasPermission('TEST_VIEW'))
    {
        navigate(`/consultation/${consultationId}/patient/${patientId}/A/antenatal?mode=${mode}`, options)
        return
    }
    if(hasPermission('TREATMENT_VIEW'))
    {
        navigate(`/consultation/${consultationId}/patient/${patientId}/A/treatment?mode=${mode}`, options)
        return
    }
}